import apiService from '../../../services/api-client';
import { DeleteBusinessResponse } from '../interfaces/delete-business';
import { GetBusinessesResponse } from '../interfaces/get-business';
import { PostBusinessPayloadRequest, PostBusinessResponse } from '../interfaces/post-business';
import { PutBusinessPayloadRequest, PutBusinessResponse } from '../interfaces/put-business';
import { PostAreaRequest, PostAreaResponse } from '../interfaces/post-area';
import { PutAreaRequest, PutAreaResponse } from '../interfaces/put-area';
import { DeleteAreaResponse } from '../interfaces/delete-area';

export const businessApiService = {
  async getBusinesses(id: number) {
    const { data } = await apiService().get<GetBusinessesResponse>(`company/${id}/businesses`);
    return data;
  },
  async postBusiness(id: number, body: PostBusinessPayloadRequest) {
    const { data } = await apiService().post<PostBusinessResponse>(`company/${id}/business`, body);
    return data;
  },
  async putBusiness(cId: number, pId: number, body: PutBusinessPayloadRequest) {
    const { data } = await apiService().put<PutBusinessResponse>(
      `company/${cId}/business/${pId}`,
      body
    );
    return data;
  },
  async deleteBusiness(cId: number, pId: number) {
    const { data } = await apiService().delete<DeleteBusinessResponse>(
      `company/${cId}/business/${pId}`
    );
    return data;
  },
  async postArea(companyId: number, businessId: number, body: PostAreaRequest) {
    const { data } = await apiService().post<PostAreaResponse>(
      `company/${companyId}/business/${businessId}/area`,
      body
    );
    return data;
  },
  async putArea(companyId: number, businessId: number, areaId: number, body: PutAreaRequest) {
    const { data } = await apiService().put<PutAreaResponse>(
      `company/${companyId}/business/${businessId}/area/${areaId}`,
      body
    );
    return data;
  },
  async deleteArea(companyId: number, businessId: number, areaId: number) {
    const { data } = await apiService().delete<DeleteAreaResponse>(
      `company/${companyId}/business/${businessId}/area/${areaId}`
    );
    return data;
  },
};
